import { render, staticRenderFns } from "./endDialog.vue?vue&type=template&id=bc439b4e"
import script from "./endDialog.vue?vue&type=script&lang=js"
export * from "./endDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports